jQuery(document).ready(function($){
  const addToCartHandler = {
    initItemAddToCartButton: function() {
      $('body').on('click', '.addtocart-item-js', function(e){
        e.preventDefault();
        const variant_id = $(this).closest('form').find('input').val();
        Shopify.addItem(variant_id, 1);
      })
    },
    initFormAddToCartButton: function(variant_id, _parent) {
      const _btn = _parent.find('.addtocart-js');
      if(_btn.length === 0) return false;
      _btn.unbind().click(function(e) {
        e.preventDefault();
        const quantity = Math.max(1, parseInt(_parent.find('.input-counter').find('input').val(), 10));
        Shopify.addItem(variant_id, quantity);
      })
    },
    addItem: function(line_item) {
      const _parent = $('header').find('.cart');
      const _empty_cart = $('.empty-cart-js');
      const _ul = _parent.find('ul:not(.item-html-js)');
      const price_str = getItemFormatedPrice(line_item.price);
      const itemhtml  = $('.item-html-js').children().clone();
      itemhtml.find('.title').find('a').attr('href', line_item.url).html(line_item.product_title);
      itemhtml.find('.price').html(price_str);
      itemhtml.find('.qty').find('input').val(line_item.quantity);
      const _img = itemhtml.find('.img').find('a');
      _img.attr('href', line_item.url).empty();
      $(`<img src='${line_item.image}' alt='Cart Image'>`).appendTo(_img);
      const _details = itemhtml.find('.details');
      line_item.variant_title === null ? _details.remove() : _details.html(line_item.variant_title.replace(/ \//g, ', '));
      const delete_btn = itemhtml.find('.delete').find('a');
      const delete_url = String(delete_btn.attr('href')).replace('id=0', `id=${line_item.id}`);
      delete_btn.attr('href', delete_url);
      itemhtml.find('.edit').find('a').attr('href', line_item.url);
      _ul.find(`[href="${delete_url}"]`).length && _ul.find(`[href="${delete_url}"]`).closest('li').remove();
      $(itemhtml).appendTo(_ul);
      !_empty_cart.hasClass('hide') && _empty_cart.addClass('hide');
    },
    updateGeneralInfo: function(cart) {
      const price_str = getItemFormatedPrice(cart.total_price);
      const _parent = $('header').find('.cart');
      const badgecart = _parent.find('.badge-cart');
      badgecart.text(cart.item_count);
      cart.item_count === 0 ? badgecart.addClass('empty') : badgecart.removeClass('empty');
      _parent.find('.cart-total').find('span:first-child').empty().html(price_str);
    }
  }

  const addedModal = {
    $modal: jQuery('#modalAddToCartProduct'),
    initSingleItem: function(line_item){
      const price_str = getItemFormatedPrice(line_item.price*line_item.quantity);
      const itemhtml = this.$modal;
      itemhtml.find('.title').html(line_item.product_title);

      const _details = itemhtml.find('.description');
      line_item.variant_title === null ? _details.hide() : _details.show().html(line_item.variant_title.replace(/ \//g, ', '));
      itemhtml.find('.qty span').first().empty().text(line_item.quantity);
      itemhtml.find('.total-product-js span').first().empty().html(price_str);

      const _img = itemhtml.find('.image-box').empty();
      $(`<img src='${line_item.image}' alt='Added Product'>`).appendTo(_img);
      addedModal.showModal();
    },
    initGeneralInfo: function(cart){
      const price_str = getItemFormatedPrice(cart.total_price);
      const itemhtml = this.$modal;
      itemhtml.find('.modal-total-quantity').text(cart.item_count);
      itemhtml.find('.full-total-js').html(price_str);
    },
    showModal: function() {
      const $this = this.$modal;
      $this.modal('show');
      const itemhtml = this.$modal;
      itemhtml.find('.close-modal-added-js').click(function(e) {
      	e.preventDefault();
      	$(this).unbind();
      	$this.modal('hide');
      });
    }
  }

  function getItemFormatedPrice(value) {
    return Shopify.formatMoney(value);
  }

  /* override functions api.jquery.js */
  Shopify.onItemAdded = function(line_item) {
    Shopify.getCart();
    addToCartHandler.addItem(line_item);
    addedModal.initSingleItem(line_item);
  };

  Shopify.onCartUpdate = function(cart) {
    addToCartHandler.updateGeneralInfo(cart);
    addedModal.initGeneralInfo(cart);
    addedModal.showModal();
    $('body').trigger('refreshCurrency');
  };

  Shopify.onError = function(XMLHttpRequest) {
    const data = XMLHttpRequest.responseText;
    let str = "";
    if (!data.message) {
      str = data.description;
    } else {
      str = `Error : ${Shopify.fullMessagesFromErrors(data).join('; ')}.`;
    }
    $('#modalAddToCartError .error_message').text(str);
    $('#modalAddToCartError').modal("toggle");
  }

  const removeFromCartHandler = function() {
    $('body').on('click', '.header_delete_cartitem_js', function(e){
      e.preventDefault();
      $(this).closest('li').addClass('removeAfterCompleteAjax');
      const variant_id = getIdFromUrl($(this).attr("href"));
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: parseFloat(variant_id),
          quantity: 0,
        },
      }).then((data) => {
        data.item_count === 0 && $('.empty-cart-js').removeClass('hide');
        $('.removeAfterCompleteAjax').remove();
        addToCartHandler.updateGeneralInfo(data);
        $('body').trigger('refreshCurrency');
      });
    });
  }

  function onCartUpdateCustom(cart) {
    cart.item_count === 0 && $('.empty-cart-js').removeClass('hide');
    $('.removeAfterCompleteAjax').remove();
    addToCartHandler.updateGeneralInfo(cart);
    $('body').trigger('refreshCurrency');
  }

  function getIdFromUrl(url) {
    url = url.match(/id=\d+/g);
    return url[0].match(/\d+/g);
  }

  addToCartHandler.initItemAddToCartButton();
  removeFromCartHandler();
});